import { render, staticRenderFns } from "./HistoricalTracing.vue?vue&type=template&id=5b24d41c&scoped=true&"
import script from "./HistoricalTracing.vue?vue&type=script&lang=js&"
export * from "./HistoricalTracing.vue?vue&type=script&lang=js&"
import style0 from "./HistoricalTracing.vue?vue&type=style&index=0&id=5b24d41c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b24d41c",
  null
  
)

export default component.exports